module.exports = __webpack_public_path__ + "img/far-badge-percent.c225abd4.svg";